import React from 'react';
import PropTypes from 'prop-types';
import { PSPSection } from 'components/molecules/PSPSection';
import { Section } from 'components/core/Page';
import { StickySearch } from '../StickySearch/StickySearch';
import './PSPLayout.scss';

function PSPLayout({ content, pageSchema, pageType, handleSearch }) {
	const { sections, type } = content;

	const triggerId =
		type === 'CubeSmart'
			? 'find-cubesmart-self-storage'
			: `psp-${pageType === 'size-guide' ? 'search-bar' : 'hero'}-sticky-search`;

	return (
		<div className={`${pageType} psp-layout`}>
			<StickySearch
				handleSearch={handleSearch}
				triggerId={triggerId}
			/>
			<Section className="psp-body">
				{sections.map((section, index) => (
					<PSPSection
						{...section}
						// eslint-disable-next-line react/no-array-index-key
						key={`${section.title}-${index}`}
					/>
				))}
			</Section>

			<script
				key="schema"
				type="application/ld+json"
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{ __html: pageSchema }}
			/>
		</div>
	);
}

PSPLayout.propTypes = {
	pageSchema: PropTypes.string,
	content: PropTypes.object,
	handleSearch: PropTypes.func,
	storageCalculatorUrl: PropTypes.string,
	disableJumpSection: PropTypes.bool,
	pageType: PropTypes.string,
};

PSPLayout.defaultProps = {
	storageCalculatorUrl: '',
};

export default PSPLayout;
